import { Avatar, AvatarInitials as GeneralAvatarInitials } from "@abel-technologies-as/components";
import { useEffect, useState } from "react";
import { placeholderAvatar } from "@/shared/constants";

const AvatarWithFallback = ({
	imageUrl,
	size = 24,
	initialsText,
}: {
	imageUrl?: string;
	size?: 24 | 32 | 40 | 48 | 56 | 64;
	initialsText?: string;
}) => {
	const [isBroken, setIsBroken] = useState(false);

	useEffect(() => {
		if (!imageUrl) {
			setIsBroken(false);
			return;
		}

		const img = new Image();
		img.onload = () => setIsBroken(false);
		img.onerror = () => setIsBroken(true);
		img.src = imageUrl;
	}, [imageUrl]);

	const shouldShowFallback = !imageUrl || isBroken;

	if (shouldShowFallback && initialsText) {
		return <GeneralAvatarInitials size={size} initials={initialsText} />;
	}

	if (shouldShowFallback) {
		return <Avatar size={size} imageUrl={placeholderAvatar} />;
	}

	return <Avatar size={size} imageUrl={imageUrl} />;
};

export { AvatarWithFallback };
